document.querySelectorAll('.item-descarga').forEach(item => {
    item.addEventListener('click', () => {
        const modal = document.getElementById('modal-descarga');
        document.getElementById('modal-img').src = item.dataset.img;
        document.getElementById('modal-titulo').innerText = item.dataset.nombre;
        modal.dataset.slug = item.dataset.slug;
        modal.style.display = 'flex';
    });
});
if(document.querySelector('.modal-content .close')){
    document.querySelector('.modal-content .close').addEventListener('click', () => {
        document.getElementById('modal-descarga').style.display = 'none';
        document.getElementById('codigo-input').value = '';
    });
}
if(document.getElementById('btn-verificar')){
    document.getElementById('btn-verificar').addEventListener('click', () => {
        const codigo = document.getElementById('codigo-input').value.trim();
        const slug = document.getElementById('modal-descarga').dataset.slug;
        const extensiones = ['jpg', 'jpeg', 'png', 'webp'];
    
        if (codigo === '') return;
    
        const tryNextExtension = (index = 0) => {
            if (index >= extensiones.length) {
                Swal.fire({
                    icon: 'error',
                    title: 'Imagen no encontrada',
                    text: 'No se ha encontrado ninguna imagen con ese código. Verifica que esté bien escrito.',
                    confirmButtonText: 'Entendido'
                });
                return;
            }
    
            const extension = extensiones[index];
            const imgPath = `/storage/descargables/${slug}/${codigo}.${extension}`;
    
            const testImg = new Image();
            testImg.onload = () => {
                window.location.href = `/descargar/${slug}?codigo=${codigo}`;
            };
            testImg.onerror = () => {
                tryNextExtension(index + 1);
            };
    
            testImg.src = imgPath;
        };
    
        tryNextExtension();    
    });
}
if(document.getElementById('btn-preview')){
    document.getElementById('btn-preview').addEventListener('click', () => {
        const codigo = document.getElementById('codigo-input').value.trim();
        const slug = document.getElementById('modal-descarga').dataset.slug;
        const extensiones = ['jpg', 'jpeg', 'png', 'webp'];
    
        if (codigo === '') return;
    
        const tryNextExtension = (index = 0) => {
            if (index >= extensiones.length) {
                Swal.fire({
                    icon: 'error',
                    title: 'Imagen no encontrada',
                    text: 'No se ha encontrado ninguna imagen con ese código. Verifica que esté bien escrito.',
                    confirmButtonText: 'Entendido'
                });
                return;
            }
    
            const extension = extensiones[index];
            const imgPath = `/storage/descargables/${slug}/${codigo}.${extension}`;
    
            const testImg = new Image();
            testImg.onload = () => {
                document.getElementById('modal-img').src = imgPath;
            };
            testImg.onerror = () => {
                tryNextExtension(index + 1);
            };
    
            testImg.src = imgPath;
        };
    
        tryNextExtension();
    });
}
